import React, { useState } from "react";
import { login } from "../api/api";
import { getOrganizationSettings } from "../api/adminApi";
import { sessionVariables } from "./util/constants";
import backgroundImage from "../assets/images/lbg.jpg";

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    
    const handleLogin = async (e) => {
        e.preventDefault();
        if (username && password) {
            try {
                const { access_token, refresh_token, role, org_id, dept_id } = await login(username, password);
                sessionStorage.setItem(
                    sessionVariables.sv_lguser,
                    JSON.stringify({
                        accessToken: access_token,
                        refreshToken: refresh_token,
                        role,
                        orgId: org_id,
                        deptId: dept_id
                    })
                );
                try {
                    const response = await getOrganizationSettings();
                    if (response.status === 200) {
                        sessionStorage.setItem(
                            sessionVariables.sv_OrgApiSetting,
                            JSON.stringify({
                                apiAddress: response.data.apiAddress || "",
                                apiKey: response.data.apiKey || "",
                                apiToken: response.data.apiToken || "",
                                username: response.data.username || "",
                                password: response.data.password || "",
                                useApiKey: response.data.useApiKey || false,
                            })
                        );
                    }
                } catch (error) {
                    alert('System failed to init Organization Settings!');
                }
                window.location.reload();
            } catch (error) {
                alert('Login failed. Please check your username and password.' + error);
                console.log(error);
            }
        } else {
            alert('Please enter a username and password');
        }
    }
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100"
            style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center", }}>
            <div className="bg-white p-8 rounded-lg shadow-md w-96">
                <h1 className="text-2xl font-bold mb-6 text-center">Login</h1>
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label htmlFor="username" className="block text-sm font-medium text-gray-700" >Username</label>
                        <input type="text" id="username" className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={username}
                            onChange={(e) => setUsername(e.target.value)} />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700" >Password</label>
                        <input type="password" id="password" className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={password}
                            onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
}
export default LoginPage;